import Crud from "../Crud";
import MUITealColor from "@mui/material/colors/teal";

/**
 * Static helper functions related to Queue Routes.
 */
export default class QueueRoute extends Crud {
  /**
   * @param {object} queueRoute The queueRoute object.
   * @returns The display name of the queueRoute.
   */
  static getDisplayName(queueRoute) {
    return queueRoute.name;
  }

  /**
   * Determines if a queueRoute matches a search query.
   *
   * @param {object} queueRoute The queueRoute to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the queueRoute matches the query.
   */
  static match(queueRoute, query) {
    return (
      queueRoute.name.toLowerCase().includes(query) || queueRoute.id === +query
    );
  }

  /**
   * @param {array} queueRoutes The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(queueRoutes) {
    return queueRoutes.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return MUITealColor;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "ForkRight";
  }

  /**
   * Resolves the first initial route (fromOrderStatusReasonId === null) configured
   * for the given order activity type.
   * @param {object} queueRoutesIndexed The queueRoutesIndexed map from MainContext.
   * @param {number} orderActivityTypeId The order activity type to resolve the initial route for.
   * @returns {object} The initial queue route.
   * @throws {Error} If no initial route is configured.
   */
  static getInitialRoute(queueRoutesIndexed, orderActivityTypeId) {
    const initialRoutes = Object.values(queueRoutesIndexed).filter(
      (route) =>
        route.orderActivityTypeId === orderActivityTypeId &&
        route.fromOrderStatusReasonId === null,
    );
    if (initialRoutes.length === 0) {
      throw new Error(
        `Expected at least one initial queue route for order activity type ${orderActivityTypeId}.`,
      );
    }
    return initialRoutes[0];
  }
}
